import api from "@wordpress/api";
import {Fragment, render, Component} from "@wordpress/element";
import {Button, Placeholder, Spinner, TextControl} from "@wordpress/components";
import {SnackbarList} from "@wordpress/components";
import {dispatch, useDispatch, useSelect} from "@wordpress/data";
import {store as noticesStore} from "@wordpress/notices";

import "./admin.scss";

// This component displays the snackbar notices on the page
const Notices = () => {
	// `useSelect` is a hook provided by the `@wordpress/data` library for subscribing to data changes.
	// Here, it gets the notices from the notices store and filters out the ones that aren't of type 'snackbar'
	const notices = useSelect(
		(select) =>
			select(noticesStore)
				.getNotices()
				.filter((notice) => notice.type === "snackbar"),
		[]
	);

	// `useDispatch` is another hook from `@wordpress/data` that returns an object with functions to dispatch actions to the store.
	// Here, it gets the `removeNotice` function from the notices store.
	const {removeNotice} = useDispatch(noticesStore);

	// Renders a `SnackbarList` component from `@wordpress/components` with the filtered notices and the `removeNotice` function.
	return (
		<SnackbarList
			className="edit-site-notices"
			notices={notices}
			onRemove={removeNotice}
		/>
	);
};

class App extends Component {

	// Set initial state
	constructor() {
		super(...arguments);

		this.state = {
			partnerToken: "",
			isAPILoaded: false,
		};
	}

	// After the component mounts, fetch settings and update state
	componentDidMount() {

		api.loadPromise.then(() => {
			// Initialize settings model
			this.settings = new api.models.Settings();

			// Get isAPILoaded from state
			const {isAPILoaded} = this.state;

			// If API is not yet loaded, fetch settings and update state
			if (isAPILoaded === false) {
				this.settings.fetch().then((response) => {
					this.setState({
						partnerToken: response["werstreamtes_widget_partner_token"],
						isAPILoaded: true,
					});
				});
			}
		});
	}

	// Render component
	render() {

		// Destructure state variables
		const {
			partnerToken,
			isAPILoaded,
		} = this.state;

		// If API is not yet loaded, display a placeholder with a spinner
		if (!isAPILoaded) {
			return (
				<Placeholder>
					<Spinner/>
				</Placeholder>
			);
		}

		// Otherwise, display the settings form
		return (
			<Fragment>

				<div className="wse-plugin__header">
					<div className="wse-plugin__container">
						<div className="wse-plugin__title">
							<a href="https://www.werstreamt.es" title="WerStreamt.es" target="_blank">
								<img alt="WerStreamt.es?"
									src={`${window.werstreamtesConfig.baseUrl}assets/WerStreamtEs.svg`}/>
							</a>
						</div>
					</div>
				</div>

				<div className="wse-plugin__main">
					{/* Form input for partner token */}
					<TextControl
						label="Partner Token"
						onChange={(partnerToken) => this.setState({partnerToken})}
						help="Wenn dir von WerStreamt.es ein Partner Token zugewiesen wurde, kannst du ihn hier eintragen. Sonst lass das Feld bitte leer."
						value={partnerToken}
					/>
					<Button className="button-primary"
							onClick={() => {

								// Get partnerToken from state
								const {
									partnerToken,
								} = this.state;

								// Initialize settings model with new partnerToken and save
								const settings = new api.models.Settings({
									["werstreamtes_widget_partner_token"]: partnerToken
								});
								settings.save();

								// Show success notice
								dispatch("core/notices").createNotice(
									"success",
									"Einstellungen erfolgreich gespeichert",
									{
										type: "snackbar",
									}
								);

							}}
					>
						Speichern
					</Button>
				</div>

				<small>
					Indem du das Widget in deine Webseite einfügst, akzeptierst du automatisch die damit
					verbundenen <a href="https://www.werstreamt.es/developers/widget/terms/"
								   target="_blank">Nutzungsbedingungen</a>.
				</small>

				<div className="wse-plugin__notices">
					<Notices/>
				</div>

			</Fragment>
		)
	}
}

/**
 * This code adds an event listener that executes a callback function when the DOM is loaded.
 * The function checks for an element with ID "widget-werstreamtes-settings".
 * If such an element exists, it renders a React component called "App" into the element using the "render" function.
 */
document.addEventListener("DOMContentLoaded", () => {
	const htmlOutput = document.getElementById("widget-werstreamtes-settings");
	if (htmlOutput) {
		render(
			<App/>,
			htmlOutput
		);
	}
});
